import { useSearchParams } from 'react-router'
import { TraderCombobox } from '@klear/ui/components/trader-combobox'
import type { WizardStepComponentProps } from '@klear/ui/wizard/flow'
import toString from 'lodash/toString'
import type { DisbursementStepCtx } from '@/app/disbursements/outlet-context'

export default function SelectTraderStep({ ctx }: WizardStepComponentProps<DisbursementStepCtx>) {
  const { state, setState } = ctx
  const [, setSearchParams] = useSearchParams()
  const traderId = state.traderId

  const onTraderChange = (id: number | null) => {
    setState((s) => ({ ...s, traderId: id, selectedAdvanceIds: [] }))
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev)
        if (id != null && id > 0) next.set('traderId', toString(id))
        else next.delete('traderId')
        return next
      },
      { replace: true }
    )
  }

  return (
    <div className="space-y-4 w-full">
      <p className="text-sm text-muted-foreground">Select the trader to disburse advances to.</p>
      <TraderCombobox value={traderId} onChange={onTraderChange} />
    </div>
  )
}
